import React from "react";

export const JobBoardContext = React.createContext();

const withJobBoardContext = (Component) => (props) => (
  <JobBoardContext.Consumer>
    {(contextProps) => <Component {...{ ...props, context: contextProps }} />}
  </JobBoardContext.Consumer>
);

export default withJobBoardContext;
